import React from 'react'
import useGlobalContext from '../hooks/useGlobalContext';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

const ToastContainner = () => {
  const {
    state: { toast },
    setToastState
  } = useGlobalContext();


  const handleClose  = () => {
    setToastState({message: '', open: false, variant: ''})
  }

  return (
    <Snackbar
      open={toast.open}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={handleClose}
      autoHideDuration={1800}
    >
      <Alert  severity={toast.variant}>
        {toast.message}
      </Alert>
    </Snackbar>
  )
}

export default ToastContainner